import { render } from "./ClientConversation.vue?vue&type=template&id=5d5c4589"
import script from "./ClientConversation.vue?vue&type=script&lang=js"
export * from "./ClientConversation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__